module.exports = __webpack_public_path__ + "img/18.11a72e12.jpg";